import { baseUrl } from '@/service/util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils/setLocaleQuery';

// 提交checkout => Whole-home
export const submitWholeHome = (data: any, locale: string) => {
    return request.post(`${baseUrl(locale)}/dpuCalcultor/submit/wholehome${setLocaleQuery(locale)}`, {
        data,
    });
};

// 提交checkout => Daily use
export const submitDailyUse = (data: any, locale: string) => {
    return request.post(`${baseUrl(locale)}/dpuCalcultor/submit/dailyuse`, {
        data,
    });
};
